import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'src/app/helpers/toastr.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { PaginationService } from 'src/app/helpers/pagination.service';
import { TrackOrdersService } from './track-order.service';

@Component({
  selector: 'app-track-order',
  templateUrl: './track-order.component.html',
  styleUrls: ['./track-order.component.scss']
})
export class TrackOrderComponent implements OnInit {

    public closeResult = '';
    public orders:any = [];
    public return_order:any = {};
    public selected_record:any = {};

    public buyer_orders: any = [];
    public current_page: number = 1;
    public offset: number = 0;
    public page_per_view: number = 10;
    public buyer_order_pagination: any = {};

    public page_per_view_options = [
        {
            value: 10,
            name: 10
        },
        {
            value: 20,
            name: 20
        }
    ];

    //return request
    public return_quantity:any = '';
    public return_reason:string = '';
    public return_message:string = '';
    public return_images:any = [];
    public return_updated_image:any = [];
    public return_status:any = '';
    public return_status_text:string = '';

    constructor(
        private modalService: NgbModal,
        private _orderservice: TrackOrdersService,
        private _toastr: ToasterService,
        private _pagination: PaginationService
    ) { }

    ngOnInit(): void {
        this.getorders();
    }
  public val = null;
    config = {
        labelField: 'label',
        valueField: 'value',
    };
	data = [
        {
            label: 'Download Labels',
            value: 'Download Labels'
        },
        {
            label: 'Download POD',
            value: 'Download POD'
        },
        {
            label: 'Download E Way Bill',
            value: 'Download E Way Bill'
        }
    ];

    setpage(page) {
        this.current_page = page;
        this.offset = (page - 1) * this.page_per_view;
        this.getorders();
    }

    setpageperview() {
        this.current_page = 1;
        this.getorders();
    }

    getorders(){
        let data = { 
            limit: this.page_per_view, 
            offset: this.offset, 
            current_page: this.current_page, 
        };
        this._orderservice.getorders(data).subscribe((data) => {
            if(data['status'] == "success"){
                this.orders = data['records'];
                let total_records = data['total_records'];
                this.buyer_order_pagination = this._pagination.getPager(total_records, this.current_page, this.page_per_view);
            }else if(data['status'] == "error"){
                this._toastr.error(data['message']);
            }
        });
    }

    acceptqcorder(record){
        this._orderservice.acceptqcorder({id: record.id}).subscribe((data) => {
            if(data['status'] == "success"){
                this._toastr.success('Products has been verified successfully.');
                this.getorders();
            }else if(data['status'] == "error"){
                this._toastr.error(data['message']);
            }
        });
    }


    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    open(content, record) {
        this.selected_record = record;
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    thumbnailsSlider = {
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        focusOnSelect: true,
        asNavFor: ".feedback",
        //prevArrow:'.client-thumbnails .prev-arrow',
        // nextArrow:'.client-thumbnails .next-arrow',
    };
    slides = [
        { img: "assets/images/admin/mfront.png" },
        { img: "assets/images/admin/back.png" },
        { img: "assets/images/admin/top.png" },

        { img: "assets/images/admin/side.png" }
    ];

    imagesSlider = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".thumbs",
    };

    openWindowReturnRequest(content, order:any) {
        this.return_order = order;
        if(this.return_order.return_request){
            this.return_quantity = this.return_order.return_request_info.quantity;
            this.return_reason = this.return_order.return_request_info.reason;
            this.return_message = this.return_order.return_request_info.message;
            this.return_status = this.return_order.return_request_info.status;
            this.return_status_text = this.return_order.return_request_info.status_text;
            this.return_updated_image = this.return_order.return_request_info.images;
        }
        this.modalService.open(content, { windowClass: 'midmodal-lg', size: 'lg', centered: true, });
    }

    submitreturn(type){
        let data = {
            meta_id: this.return_order.id,
            type:type
        }
        this._orderservice.acceptrejectreturn(data).subscribe((data) => {
            if (data['status'] == "success") {
                if(type == 'approve'){
                    this._toastr.success('Return request has been accepted successfully.');
                }else if(type == 'reject'){
                    this._toastr.success('Return request has been rejected successfully.');
                }
                this.modalService.dismissAll();
                this.getorders();
            } else if (data['status'] == "error") {
                this._toastr.error(data['message']);
            }
        }, (error) => {
            this._toastr.error(data['message']);
        });
    }

    initpickup(type){
        let data = {
            meta_id: this.return_order.id,
            type:type
        }
        this._orderservice.initpickup(data).subscribe((data) => {
            if (data['status'] == "success") {
                if(type == 'readytopickup'){
                    this._toastr.success('Return pickup has been initiated');
                }else if(type == 'delivered'){
                    this._toastr.success('Return request products has been delivered.');
                }
                this.modalService.dismissAll();
                this.getorders();
            } else if (data['status'] == "error") {
                this._toastr.error(data['message']);
            }
        }, (error) => {
            this._toastr.error(data['message']);
        });
    }

}
